import { isAlipay } from '../channel/setUserChannel'
/**
 *
 * 解决h5下微信环境和支付宝环境下标题不更新的问题
 *
 * @param {string} title
 */
export const setDocumentTitle = function (title) {
  const titleEle = document.getElementsByTagName('title') && document.getElementsByTagName('title')[0]
  // IOS 支付宝标题不更新 强制更新标题方法
  // eslint-disable-next-line no-undef
  if (isAlipay() && AlipayJSBridge) {
    // eslint-disable-next-line no-undef
    AlipayJSBridge.call('setTitle', {
      title
    })
    return
  }

  if (titleEle && titleEle.innerHTML) {
    titleEle.innerHTML = title
  }
}
